export default [
    {
        path: '/serverQa',
        name: 'serverQa',
        meta: {
            title: '常见问题答疑',
            activity: true
        },
        component: () => import('@/views/serverQa/index.vue')
    },

]
